module.exports = __webpack_public_path__ + "static/colgadas-017.thumb-e5c6917486db616a413e127a3ffcfebf.jpg";